import { type IColumn } from 'shared/ui'
import { type RowNumber } from 'entities/Phone/model/Table/RowNumber'

export const typeCell: IColumn<RowNumber> = {
  field: 'labelType',
  name: 'Type',
  sortKey: 'type',
  isSortable: true,
}
